module.exports = __webpack_public_path__ + "img/sy.bcea95b6.png";